"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _pushSwitch = _interopRequireDefault(require("./pushSwitch.vue"));
var _pushHuaWeiConfig = _interopRequireDefault(require("./pushHuaWeiConfig.vue"));
var _pushXiaoMiConfig = _interopRequireDefault(require("./pushXiaoMiConfig.vue"));
var _pushVivoConfig = _interopRequireDefault(require("./pushVivoConfig.vue"));
var _pushHonorConfig = _interopRequireDefault(require("./pushHonorConfig.vue"));
var _pushOppoConfig = _interopRequireDefault(require("./pushOppoConfig.vue"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    pushSwitch: _pushSwitch.default,
    pushHuaWeiConfig: _pushHuaWeiConfig.default,
    pushXiaoMiConfig: _pushXiaoMiConfig.default,
    pushVivoConfig: _pushVivoConfig.default,
    pushHonorConfig: _pushHonorConfig.default,
    pushOppoConfig: _pushOppoConfig.default
  },
  data: function data() {
    return {
      loading: false,
      activeVendor: 'huawei',
      jguangBaseConfig: {},
      huaweiConfig: {},
      oppoConfig: {},
      xiaomiConfig: {},
      vivoConfig: {},
      honorConfig: {},
      // 极光：appKey / masterSecret；袤博：mobAppKey / mobMasterSecret
      // 推送开关不在当前界面展示，但保留在提交数据中，避免保存时被覆盖丢失
      ruleForm: {
        appKey: '',
        masterSecret: '',
        mobAppKey: '',
        mobMasterSecret: '',
        activMode: 1,
        androidPushStatus: 1,
        iosPushStatus: 1,
        harmonyPushStatus: 1
      },
      rules: {
        appKey: [{
          required: true,
          message: '请输入App Key',
          trigger: 'blur'
        }],
        masterSecret: [{
          required: true,
          message: '请输入Master Secret',
          trigger: 'blur'
        }],
        mobAppKey: [{
          required: true,
          message: '请输入mob AppKey',
          trigger: 'blur'
        }],
        mobMasterSecret: [{
          required: true,
          message: '请输入mob MasterSecret',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 激活的渠道 1：极光（默认） 2：袤博
    activMode: function activMode() {
      return Number(this.jguangBaseConfig.activMode) || 1;
    },
    channelName: function channelName() {
      return this.activMode === 2 ? 'Mob Tech' : '极光推送';
    },
    // 当前编辑渠道是否为袤博（用于表单字段/文案切换）
    isMob: function isMob() {
      return Number(this.activMode) === 2;
    },
    // 通知栏中使用的渠道名称（与顶部徽标 channelName 区分）
    noticeChannelName: function noticeChannelName() {
      return this.isMob ? '袤博(Mob Tech)' : '极光推送';
    },
    // 当前渠道对应的字段
    fieldKeys: function fieldKeys() {
      return this.isMob ? {
        appKey: 'mobAppKey',
        secret: 'mobMasterSecret'
      } : {
        appKey: 'appKey',
        secret: 'masterSecret'
      };
    }
  },
  watch: {
    jguangBaseConfig: {
      handler: function handler(val) {
        // 从配置回填表单，避免切换/刷新后 App Key 等参数丢失
        this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.ruleForm), val);
      },
      immediate: true,
      deep: true
    },
    // 切换渠道后清除校验提示
    activMode: function activMode() {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.ruleForm1 && _this.$refs.ruleForm1.clearValidate();
      });
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.loading = true;
      (0, _threePartyConfiguration.queryThirdConfig)({
        type: 1
      }).then(function (res) {
        _this2.loading = false;
        var jigangConfig = res.data && res.data.jigangConfig || {};
        _this2.jguangBaseConfig = jigangConfig.jguangBaseConfig || {};
        _this2.huaweiConfig = jigangConfig.huaweiConfig || {};
        _this2.oppoConfig = jigangConfig.oppoConfig || {};
        _this2.xiaomiConfig = jigangConfig.xiaomiConfig || {};
        _this2.vivoConfig = jigangConfig.vivoConfig || {};
        _this2.honorConfig = jigangConfig.honorConfig || {};
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 切换推送服务商（立即生效，无需重新打包）
    onSelectChannel: function () {
      var _onSelectChannel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(mode) {
        var _t, _t2;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.activMode === mode)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return this.$confirm("\u786E\u8BA4\u5C06\u63A8\u9001\u670D\u52A1\u5546\u5207\u6362\u4E3A".concat(mode === 1 ? '极光推送' : 'Mob Tech', "\uFF1F\u5207\u6362\u540E\u9700\u8981\u6253\u5305\u751F\u6548\u3002"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              return _context.a(2);
            case 4:
              _context.p = 4;
              _context.n = 5;
              return (0, _threePartyConfiguration.thirdConfig)({
                type: 1,
                jigangConfig: {
                  type: 0,
                  // 合并当前表单数据，避免用陈旧的 jguangBaseConfig 把已填的 App Key 覆盖成空
                  jguangBaseConfig: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.jguangBaseConfig), this.ruleForm), {}, {
                    activMode: mode
                  })
                }
              });
            case 5:
              this.jguangBaseConfig = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.jguangBaseConfig), {}, {
                activMode: mode
              });
              // 重新拉取配置，让子组件拿到目标渠道的凭证字段，避免切换后参数不显示
              _context.n = 6;
              return this.init();
            case 6:
              this.$notify.success({
                title: '温馨提示',
                message: '切换成功！'
              });
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t2 = _context.v;
              console.log(_t2);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[4, 7], [1, 3]]);
      }));
      function onSelectChannel(_x) {
        return _onSelectChannel.apply(this, arguments);
      }
      return onSelectChannel;
    }(),
    jump: function jump(val) {
      window.open(val);
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _threePartyConfiguration.thirdConfig)({
              type: 1,
              jigangConfig: {
                type: 0,
                jguangBaseConfig: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.ruleForm), {}, {
                  activMode: _this3.activMode
                })
              }
            }).then(function (res) {
              _this3.$notify.success({
                title: '温馨提示',
                message: '保存成功！'
              });
              // 保存成功后重新查询最新配置（/portal/system/tenant/queryThirdConfig）
              (0, _threePartyConfiguration.queryThirdConfig)({
                type: 1
              }).then(function (qres) {
                var cfg = qres.data && qres.data.jigangConfig && qres.data.jigangConfig.jguangBaseConfig;
                if (cfg) {
                  // 同步配置缓存（watch 会回填 ruleForm），避免后续切换渠道用旧数据覆盖
                  _this3.jguangBaseConfig = (0, _objectSpread2.default)({}, cfg);
                }
              });
            });
          });
        } else {
          return false;
        }
      });
    },
    jumpTutorial: function jumpTutorial() {
      window.open('https://www.yuque.com/weixu-spa2e/pe5gxx/sq0mrgyzm1z2z7u2');
    }
  }
};